import React, { useState } from 'react';

import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import loadingSpin from './../../../assets/images/LoadingSpin.gif';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useEffect } from 'react';

function TimingComponenet(props) {
  const [radiovalue, setRadioValue] = React.useState('SpecifyOK');
  const [isactive, setIsactive] = React.useState(false);
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log((event.target as HTMLInputElement).value);
    setRadioValue((event.target as HTMLInputElement).value);
  };
  console.log(radiovalue);
  const [switchCheck, setswitchCheck] = React.useState(false);
  const [allDayswitchCheck, setallDayswitchCheck] = React.useState(false);
  const [selectDay, setSelectDay] = React.useState(true);
  const [mselectDay, setMSelectDay] = React.useState(true);
  const [TselectDay, setTSelectDay] = React.useState(true);
  const [WselectDay, setWSelectDay] = React.useState(true);
  const [T1selectDay, setT1SelectDay] = React.useState(true);
  const [FselectDay, setFSelectDay] = React.useState(true);
  const [SselectDay, setSSelectDay] = React.useState(true);
  const [fromTime, setfromTime] = React.useState(null);
  const [toTime, settoTime] = React.useState(null);

  const [fromDate, setfromDate] = React.useState(null);
  const [toDate, settoDate] = React.useState(null);

  const [timingTableDatas, setTimingTableDatas] = React.useState([]);
  const [temptimingTableDatas, settemptimingTableDatas] = React.useState([]);
  const [dayTableDatas, setdayTableDatas] = React.useState([]);

  const clearDays = () => {
    setSelectDay(true);
    setMSelectDay(true);
    setTSelectDay(true);
    setWSelectDay(true);
    setT1SelectDay(true);
    setFSelectDay(true);
    setSSelectDay(true);
  };

  const formatDate = (date) => (date ? moment(date).format('DD-MM-YYYY') : '');

  const [selectedData, setSelectedData] = React.useState([]);

  var data = {
    scheduleDateTimeView: {
      isAllDay: !allDayswitchCheck,
      fromTimeAsMinutes: fromTime,
      toTimeAsMinutes: toTime,
      isFixedDate: switchCheck,
      fromDate: fromDate,
      toDate: toDate,
      isDays: false,
      creatorId: 'string',
    },
    scheduleDaysView: {
      isFriday: false,
      isSaturday: false,
      isSunday: false,
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      creatorId: 'string',
    },
  };

  React.useEffect(() => {
    setTimingTableDatas(temptimingTableDatas);
    props.selectedData(temptimingTableDatas);
  }, [timingTableDatas]);

  const removeData = (props) => {
    let tempData = temptimingTableDatas;
    let data = tempData.find((x) => x.Id === props);
    if (data != undefined) {
      const index = tempData.indexOf(data);
      if (index > -1) {
        // only splice array when item is found
        tempData.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    settemptimingTableDatas(tempData);
    setTimingTableDatas([]);
  };

  const setTimeTable = () => {
    if (fromDate && toDate) {
      let dateRange = formatDate(fromDate) + ' to ' + formatDate(toDate);
      dayTableDatas.push({
        name: dateRange,
        ShortName: 'fixedDate',
        FromDate: fromDate,
        ToDate: toDate,
        IsDateRange: switchCheck,
      });
    }
    if (!allDayswitchCheck) {
      timing = 'All Day';
    } else {
      var timing = fromTime + ' - ' + toTime;
    }
    temptimingTableDatas.push({
      Id: temptimingTableDatas.length + 1,
      timing: timing,
      days: dayTableDatas,
      IsTiming: allDayswitchCheck,
      FromTime: fromTime,
      ToTime: toTime,
    });
    setdayTableDatas([]);
    setTimingTableDatas(temptimingTableDatas);
    clearDays();
    props.selectedData(temptimingTableDatas);
  };
  const [isFixedDate, setisFixedDate] = React.useState();

  //   const setDay = (props) => {
  //     console.log('props: ' + props);
  //     switch (props) {
  //       case 'S':
  //         dayTableDatas.push({
  //           name: 'Sunday',
  //           ShortName: 'S',
  //         });
  //         break;
  //       case 'S1':
  //         dayTableDatas.push({
  //           name: 'Saturday',
  //           ShortName: 'S1',
  //         });
  //         break;
  //       case 'M':
  //         dayTableDatas.push({
  //           name: 'Monday',
  //           ShortName: 'M',
  //         });
  //         break;
  //       case 'T':
  //         dayTableDatas.push({
  //           name: 'TuesDay',
  //           ShortName: 'T',
  //         });
  //         break;
  //       case 'W':
  //         dayTableDatas.push({
  //           name: 'Wednessday',
  //           ShortName: 'W',
  //         });
  //         break;
  //       case 'T1':
  //         dayTableDatas.push({
  //           name: 'Thursday',
  //           ShortName: 'T1',
  //         });
  //         break;
  //       case 'F':
  //         dayTableDatas.push({
  //           name: 'Friday',
  //           ShortName: 'F',
  //         });
  //         break;
  //       default:
  //         return 'Nothing';
  //     }
  //   };
  const setDay = (props) => {
    // Check if the day already exists in dayTableDatas
    const exists = dayTableDatas.some((day) => day.ShortName === props);

    if (exists) {
      console.log(`Day with ShortName ${props} already exists.`);
      return; // Exit early to avoid adding duplicates
    }

    // Define a mapping for day names
    const dayMapping = {
      S: { name: 'Sunday', ShortName: 'S' },
      S1: { name: 'Saturday', ShortName: 'S1' },
      M: { name: 'Monday', ShortName: 'M' },
      T: { name: 'Tuesday', ShortName: 'T' },
      W: { name: 'Wednesday', ShortName: 'W' },
      T1: { name: 'Thursday', ShortName: 'T1' },
      F: { name: 'Friday', ShortName: 'F' },
    };

    // Get the corresponding day object
    const dayData = dayMapping[props];

    if (dayData) {
      dayTableDatas.push(dayData);
      console.log(`Added day: ${dayData.name}`);
    } else {
      console.log('Invalid day identifier');
      return 'Nothing';
    }
  };

  const setdate = (props) => {
    console.log('props: ' + props);
    dayTableDatas.push({
      name: props,
      ShortName: 'fixedDate',
    });
  };
  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
  };
  const handleAllDaySwitchChange = () => {
    setallDayswitchCheck(!allDayswitchCheck);
  };

  console.log('date___', fromDate, toDate);

  const onSubmit = () => {
    var tempData = [];
    timingTableDatas.map((dt, index) => {
      const d = new Date();
      var data = {
        scheduleDateTimeView: {
          isAllDay: false,
          fromTimeAsMinutes: d.getTime().toString(),
          toTimeAsMinutes: d.getTime().toString(),
          isFixedDate: false,
          fromDate: new Date(),
          toDate: new Date(),
          isDays: false,
          creatorId: 'string',
        },
        scheduleDaysView: {
          isFriday: false,
          isSaturday: false,
          isSunday: false,
          isMonday: false,
          isTuesday: false,
          isWednesday: false,
          isThursday: false,
          creatorId: 'string',
        },
      };
      if (dt.IsTiming == false) {
        data.scheduleDateTimeView.isAllDay = true;
      } else {
        data.scheduleDateTimeView.fromTimeAsMinutes = dt.FromTime;
        data.scheduleDateTimeView.toTimeAsMinutes = dt.ToTime;
      }

      dt.days.map((day, indexDay) => {
        if (day.IsDateRange || (day.FromDate && day.ToDate)) {
          data.scheduleDateTimeView.isFixedDate = true;
          data.scheduleDateTimeView.fromDate = day.FromDate;
          data.scheduleDateTimeView.toDate = day.ToDate;
        } else {
          data.scheduleDateTimeView.isDays = true;
          switch (day.ShortName) {
            case 'S':
              data.scheduleDaysView.isSunday = true;
              break;
            case 'S1':
              data.scheduleDaysView.isSaturday = true;
              break;
            case 'M':
              data.scheduleDaysView.isMonday = true;
              break;
            case 'T':
              data.scheduleDaysView.isTuesday = true;
              break;
            case 'W':
              data.scheduleDaysView.isWednesday = true;
              break;
            case 'T1':
              data.scheduleDaysView.isThursday = true;
              break;
            case 'F':
              data.scheduleDaysView.isFriday = true;
              break;
            default:
              return 'Nothing';
          }
        }
      });
      tempData.push(data);
    });
    var sendingData = {
      is27By7: radiovalue,
      data: tempData,
    };
    // console.log(tempData);
    setSelectedData(tempData);
    // console.log(selectedData);
    // console.log(timingTableDatas);
    console.log('dayTableDatas___2', sendingData);
    props.onsubmit(sendingData);
  };

  // start
  const [specifyTimeDateCheck, setSpecifyTimeDateCheck] = useState(false);
  const handleSpecifyTimeDate = () => {
    setSpecifyTimeDateCheck(!specifyTimeDateCheck);
    if (!specifyTimeDateCheck) {
      setRadioValue('SpecifyOK');
    } else {
      setRadioValue('24/7');
    }
    setAlldayswitchCheck(false);
  };
  const [AlldayswitchCheck, setAlldayswitchCheck] = useState(false);
  const handleAlldaySwitchChange = () => {
    setAlldayswitchCheck(!AlldayswitchCheck);
    if (!AlldayswitchCheck) {
      setRadioValue('24/7');
    } else {
      setRadioValue('SpecifyOK');
    }
    setSpecifyTimeDateCheck(false);
  };

  const [WeekdayswitchCheck, setWeekdayswitchCheck] = useState(false);
  const handleWeekdaySwitchChange = () => {
    setWeekdayswitchCheck(!WeekdayswitchCheck);
    setDateRangeCheck(false);
    setfromDate(null);
    settoDate(null);
    setfromTime(null);
    settoTime(null);

    setdayTableDatas([]);
    clearDays();

    if (!WeekdayswitchCheck && !DateRangeCheck) {
      setAlldayswitchCheck(false);
    }
  };
  const [DateRangeCheck, setDateRangeCheck] = useState(false);
  const handleDateRange = () => {
    setDateRangeCheck(!DateRangeCheck);
    setWeekdayswitchCheck(false);
    setfromDate(null);
    settoDate(null);
  };

  useEffect(() => {
    setfromTime(null);
    settoTime(null);

    setallDayswitchCheck(false);
  }, [WeekdayswitchCheck, DateRangeCheck]);

  console.log('dayTableDatas___', allDayswitchCheck);

  const isAddEnabled =
    specifyTimeDateCheck &&
    ((WeekdayswitchCheck && dayTableDatas.length !== 0) ||
      (DateRangeCheck && fromDate && toDate)) &&
    (!allDayswitchCheck || (allDayswitchCheck && fromTime && toTime));

  const isSaveEnabled = AlldayswitchCheck || temptimingTableDatas.length > 0;

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 520,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  //tooltip end

  return (
    <div className='d-flex' style={{ gap: '10px', flexDirection: 'column' }}>
      {/* <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={radiovalue}
                onChange={handleRadioChange}
            >
                <FormControlLabel value="24/7" control={<Radio />} label="Open 24/7" />
                <span style={{paddingTop:'0.3rem', paddingRight:'0.5rem', fontSize:'1.2rem'}}>- or -</span>
                <FormControlLabel value="SpecifyOK" control={<Radio />} label="Specify time and date" />
            </RadioGroup> */}
      <div className='d-flex gap-2' style={{ alignItems: 'center' }}>
        <Switch
          checked={AlldayswitchCheck}
          onChange={handleAlldaySwitchChange}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        <span>Open 24/7</span>

        <span> - Or - </span>
        <Switch
          checked={specifyTimeDateCheck}
          onChange={handleSpecifyTimeDate}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        <span>Specify time and date</span>
      </div>
      {specifyTimeDateCheck ? (
        <>
          <div
            className={`${radiovalue === 'SpecifyOK' ? '' : 'disabledifClose'}`}
          >
            {/* <Switch
                    checked={switchCheck}
                    onChange={handleSwitchChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
                <span>Fixed Date</span> */}
            <div className='d-flex gap-2' style={{ alignItems: 'center' }}>
              <Switch
                checked={WeekdayswitchCheck}
                onChange={handleWeekdaySwitchChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <span>Any weekday</span>

              <span> - Or - </span>
              <Switch
                checked={DateRangeCheck}
                onChange={handleDateRange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <span>Specify date range</span>
            </div>
          </div>
          {WeekdayswitchCheck && (
            <>
              <div
                className={`d-flex ${
                  radiovalue === 'SpecifyOK' ? '' : 'disabledifClose'
                }`}
                style={{ gap: '10px' }}
              >
                <button
                  className={` circleBtn ${
                    selectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setSelectDay(!selectDay);
                    setDay('S');
                  }}
                >
                  S
                </button>
                <button
                  className={` circleBtn ${
                    mselectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setMSelectDay(!mselectDay);
                    setDay('M');
                  }}
                >
                  M
                </button>
                <button
                  className={` circleBtn ${
                    TselectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setTSelectDay(!TselectDay);
                    setDay('T');
                  }}
                >
                  T
                </button>
                <button
                  className={` circleBtn ${
                    WselectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setWSelectDay(!WselectDay);
                    setDay('W');
                  }}
                >
                  W
                </button>
                <button
                  className={` circleBtn ${
                    T1selectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setT1SelectDay(!T1selectDay);
                    setDay('T1');
                  }}
                >
                  T
                </button>
                <button
                  className={` circleBtn ${
                    FselectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setFSelectDay(!FselectDay);
                    setDay('F');
                  }}
                >
                  F
                </button>
                <button
                  className={` circleBtn ${
                    SselectDay ? 'colorNotSelected' : 'colorSelected'
                  } `}
                  onClick={() => {
                    setSSelectDay(!SselectDay);
                    setDay('S1');
                  }}
                >
                  S
                </button>
              </div>
            </>
          )}
          {/* {DateRangeCheck && (
            <div
              className={`${
                radiovalue === 'SpecifyOK' ? '' : 'disabledifClose'
              }`}
            >
              <div className='d-flex w-100' style={{ gap: '10px' }}>
                <Typography style={{}}>From</Typography>
                <input
                  type='date'
                  id='appt'
                  name='appt'
                  className='form-control'
                  onChange={(ev) => {
                    setfromDate(ev.target.value);
                  }}
                />
                <Typography style={{}}>to</Typography>
                <input
                  type='date'
                  id='appt'
                  name='appt'
                  className='form-control'
                  onChange={(ev) => {
                    settoDate(ev.target.value);
                  }}
                />
              </div>
            </div>
          )} */}
          {DateRangeCheck && (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <div>
                <Box
                  display='flex'
                  alignItems='center'
                  gap={2}
                  className='date-picker-container'
                >
                  <Typography>From</Typography>
                  <DatePicker
                    label='Start Date'
                    value={fromDate}
                    onChange={(newValue) => setfromDate(newValue)}
                    disableFuture={false}
                    renderInput={(params) => (
                      <input {...params} className='form-control' />
                    )}
                  />
                  <Typography>to</Typography>
                  <DatePicker
                    label='End Date'
                    value={toDate}
                    onChange={(newValue) => settoDate(newValue)}
                    shouldDisableDate={(date) => fromDate && date < fromDate}
                    disablePast
                    renderInput={(params) => (
                      <input {...params} className='form-control' />
                    )}
                  />
                </Box>
              </div>
            </LocalizationProvider>
          )}
          {/* {!switchCheck ? (
                <>
                    <div className={`d-flex ${radiovalue === "SpecifyOK" ? "" : "disabledifClose"}`} style={{ gap: "10px" }}>
                        <button className={` circleBtn ${selectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setSelectDay(!selectDay); setDay("S") }}>
                            S
                        </button>
                        <button className={` circleBtn ${mselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setMSelectDay(!mselectDay); setDay("M") }}>
                            M
                        </button>
                        <button className={` circleBtn ${TselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setTSelectDay(!TselectDay); setDay("T") }}>
                            T
                        </button>
                        <button className={` circleBtn ${WselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setWSelectDay(!WselectDay); setDay("W") }}>
                            W
                        </button>
                        <button className={` circleBtn ${T1selectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setT1SelectDay(!T1selectDay); setDay("T1") }}>
                            T
                        </button>
                        <button className={` circleBtn ${FselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setFSelectDay(!FselectDay); setDay("F") }}>
                            F
                        </button>
                        <button className={` circleBtn ${SselectDay ? "colorNotSelected" : "colorSelected"} `} onClick={() => { setSSelectDay(!SselectDay); setDay("S1") }}>
                            S
                        </button>
                    </div>
                </>

            ) :
                <div className={`${radiovalue === "SpecifyOK" ? "" : "disabledifClose"}`}>
                    <div className='d-flex w-100' style={{ gap: "10px" }}>
                        <Typography style={{}}>
                            From
                        </Typography>
                        <input type="date" id="appt" name="appt" className='form-control' onChange={(ev) => { setfromDate(ev.target.value) }} />
                        <Typography style={{}}>
                            to
                        </Typography>
                        <input type="date" id="appt" name="appt" className='form-control' onChange={(ev) => { settoDate(ev.target.value) }} />
                    </div>


                </div>
            } */}
          {(WeekdayswitchCheck || DateRangeCheck) && (
            <div
              className={`${
                radiovalue === 'SpecifyOK' ? '' : 'disabledifClose'
              }`}
            >
              <Switch
                checked={allDayswitchCheck}
                onChange={handleAllDaySwitchChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <span>Specify opening hours (24hrs by default)</span>
            </div>
          )}
          {allDayswitchCheck ? (
            <div
              className={`d-flex ${
                radiovalue === 'SpecifyOK' ? '' : 'disabledifClose'
              } `}
              style={{ gap: '10px' }}
            >
              <Typography style={{}}>From</Typography>
              <input
                type='time'
                id='appt'
                name='appt'
                className='form-control'
                onChange={(ev) => {
                  setfromTime(ev.target.value);
                }}
              />
              <Typography style={{}}>to</Typography>
              <input
                type='time'
                id='appt'
                name='appt'
                className='form-control'
                onChange={(ev) => {
                  settoTime(ev.target.value);
                }}
              />
            </div>
          ) : (
            ''
          )}
          <div className='d-flex mt-3 w-100 d-flex gap-2 justify-content-end'>
            <span>
              <b>Hint:</b>You can add multiple time and day combination to a
              schedule and plan ahead.
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color='inherit'>
                      Low priority: You can first add a time period ‘24/7’
                      <br></br>
                      Medium priority (Unspecified date range and specific time
                      range: Then if you have specific opening hours at
                      weekends, add a time period for ‘Saturday, Sunday:
                      9am-5pm’ and on any Saturday and Sunday this will override
                      the 24hrs schedule.<br></br>
                      High priority (Specific date range and unspecified time
                      range): You can further add a time period for ‘Saturday
                      29th Sept to Sunday 30th Sept – no time set’ and on those
                      specific weekend dates only, the schedule will run for
                      24hrs, overriding the previous 9 to 5 schedule for any
                      weekend.<br></br>
                      Highest priority (Specific date range and specific time
                      range): You can further add a specific time for ‘Sunday
                      30th Sept – 10am-4pm’ and on that specific day, the
                      schedule will run only for that time range of 10am to 4pm
                      and override the previous 24hrs schedule for that day.
                    </Typography>
                  </React.Fragment>
                }
              >
                <b>See examples</b>
              </HtmlTooltip>
            </span>
            <button
              className='btn btn-success '
              style={{ width: '10rem' }}
              disabled={!isAddEnabled}
              onClick={() => setTimeTable()}
            >
              Add
            </button>
          </div>
          <table className='table text-center'>
            <thead>
              <tr>
                <th>Timing</th>
                <th>Days</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {timingTableDatas.map((name, index) => (
                <tr key={index}>
                  <td className='text-center'>{name.timing}</td>
                  <td className='text-center'>
                    <p>
                      {name.days.map((d, index) => {
                        return (
                          <>
                            {d.name}
                            {name.days.length - 1 != index ? ',' : ''}
                          </>
                        );
                      })}
                    </p>
                  </td>
                  <td className='text-center'>
                    <button
                      className='btn btn-danger'
                      onClick={() => removeData(name.Id)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        ''
      )}
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid item xs={12} sx={{ justifyContent: 'right', display: 'flex' }}>
          <Button
            className={`AddItemButtons ${props.loading ? 'nonePointer' : ''}`}
            disabled={!isSaveEnabled}
            onClick={() => onSubmit()}
            style={{
              pointerEvents: !isSaveEnabled || props.loading ? 'none' : 'auto',
              opacity: !isSaveEnabled || props.loading ? 0.6 : 1,
            }}
          >
            {props.loading ? (
              <img src={loadingSpin} alt='' style={{ width: '1.2rem' }} />
            ) : (
              'Save'
            )}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default TimingComponenet;
